export default __webpack_public_path__ + "static/media/MY.1c345ba1.svg";